import { Controller } from "@hotwired/stimulus";
import { CartAddEvent } from "@theme/events";

class SwatWishlistController extends Controller {
  #boundHandleAddedToCartFromWishlist = null;
  #swatListenerSetup = false;

  connect() {
    this.#observeForSwat();

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.#loadWishlistButtonsOnCollectionsLoaded);
  }

  disconnect() {
    this.#cleanupSwatListener();
    this.#swatListenerSetup = false;
  }

  #loadWishlistButtonsOnCollectionsLoaded(swat) {
    document.addEventListener("swym:collections-loaded", function () {
      swat.initializeActionButtons("product-recommendations");
      swat.initializeActionButtons("[data-controller='pagination']");
    });
  }

  // Check for SWAT script and evtLayer on page load.
  // It might not be available immediately so, if that's the case
  // observe for script additions and setup the listener when it's available.
  #observeForSwat() {
    if (window._swat && window._swat.evtLayer) {
      this.#setupSwatListener();
      return;
    }

    const observer = new MutationObserver((_mutations) => {
      if (window._swat && window._swat.evtLayer && !this.#swatListenerSetup) {
        this.#setupSwatListener();
        observer.disconnect();
      }
    });

    observer.observe(document.head, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      observer.disconnect();
      if (window._swat && window._swat.evtLayer && !this.#swatListenerSetup) {
        this.#setupSwatListener();
      }
    }, 10000);
  }

  #setupSwatListener() {
    if (this.#swatListenerSetup) {
      return;
    }

    this.#boundHandleAddedToCartFromWishlist =
      this.#handleAddedToCartFromWishlist.bind(this);
    window._swat.evtLayer.addEventListener(
      "sw:addedtocart",
      this.#boundHandleAddedToCartFromWishlist,
    );
    this.#swatListenerSetup = true;
  }

  #cleanupSwatListener() {
    if (
      this.#boundHandleAddedToCartFromWishlist &&
      window._swat &&
      window._swat.evtLayer
    ) {
      window._swat.evtLayer.removeEventListener(
        "sw:addedtocart",
        this.#boundHandleAddedToCartFromWishlist,
      );
    }
  }

  #handleAddedToCartFromWishlist(event) {
    document.dispatchEvent(
      new CartAddEvent({}, this.id, {
        source: "sw:addedtocart",
        itemCount: event.detail.d.quantity,
        productId: event.detail.d.productData.id,
      }),
    );
  }
}

Stimulus.register("swat-wishlist", SwatWishlistController);
